import axios from "axios";

function sameOrigin() {
  if (typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin.replace(/\/$/, "");
  }
  return "";
}

export const API = `${sameOrigin()}/api`;

export const api = axios.create({
  baseURL: sameOrigin(),
  withCredentials: true,
});

async function parseBlobError(err) {
  const data = err?.response?.data;
  if (typeof Blob !== "undefined" && data instanceof Blob) {
    try {
      const json = JSON.parse(await data.text());
      err.response.data = json;
    } catch { /* se mantiene el blob */ }
  }
  return err;
}

function filenameFromDisposition(header, fallbackName) {
  const cd = header || "";
  const star = cd.match(/filename\*=(?:UTF-8'')?([^;]+)/i);
  if (star) {
    try { return decodeURIComponent(star[1].trim().replace(/^["']|["']$/g, "")); }
    catch { /* ignore */ }
  }
  const plain = cd.match(/filename=["']?([^"';]+)/i);
  return plain ? plain[1].trim() : fallbackName;
}

export async function downloadApiFile(path, { params, fallbackName } = {}) {
  try {
    const res = await api.get(path, { params, responseType: "blob" });
    const data = res.data;
    if (data.type && (data.type.includes("json") || data.type.includes("text/plain"))) {
      const text = await data.text();
      let detail;
      try { detail = JSON.parse(text).detail; } catch { detail = text; }
      const e = new Error(typeof detail === "string" ? detail : "No se pudo descargar el archivo");
      e.response = { data: { detail } };
      throw e;
    }
    const name = filenameFromDisposition(res.headers["content-disposition"], fallbackName || "descarga");
    const url = URL.createObjectURL(data);
    const a = document.createElement("a");
    a.href = url;
    a.download = name;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 60_000);
  } catch (err) {
    throw await parseBlobError(err);
  }
}

export async function fetchDecaPdfBlob(decaId) {
  try {
    const { data } = await api.get(`/api/v1/decas/${decaId}/pdf`, { responseType: "blob" });
    if (data.type && !data.type.includes("pdf")) {
      const text = await data.text();
      let detail;
      try { detail = JSON.parse(text).detail; } catch { detail = text; }
      const e = new Error(typeof detail === "string" ? detail : "No se pudo abrir el PDF");
      e.response = { data: { detail } };
      throw e;
    }
    return new Blob([data], { type: "application/pdf" });
  } catch (err) {
    throw await parseBlobError(err);
  }
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Ha ocurrido un error. Inténtalo de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
